module.exports = __webpack_public_path__ + "img/ruby.9d6633d7.svg";